import { render, staticRenderFns } from "./modalRemisiones.vue?vue&type=template&id=0187e5f6&"
import script from "./modalRemisiones.vue?vue&type=script&lang=js&"
export * from "./modalRemisiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports